import { type FC, type ReactNode } from "react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { type ArrowPosition } from "@root/shared/types/type";
import * as styles from "./styles.css";

type Props = {
  children: ReactNode;
  className?: string;
  arrowPosition: ArrowPosition;
  right: string;
  left: string;
  bottom: string;
  top: string;
  zIndex: string;
};

export const Presentation: FC<Props> = ({
  children,
  className,
  arrowPosition,
  bottom,
  top,
  right,
  left,
  zIndex,
}) => {
  return (
    <div
      className={`${styles.variant({ arrowPosition })} ${className}`}
      style={assignInlineVars({
        [styles.bottom]: bottom,
        [styles.top]: top,
        [styles.right]: right,
        [styles.left]: left,
        [styles.zIndex]: zIndex,
      })}
    >
      <div className={styles.inner}>{children}</div>
    </div>
  );
};
